// User Role enum matching backend
export type UserRole = 'ADMIN' | 'MANAGER' | 'USER';

// User interface (full)
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isActive: boolean;
  emailNotificationsEnabled: boolean;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// Create User DTO
export interface CreateUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role?: UserRole;
}

// Update User DTO
export interface UpdateUserDto {
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  isActive?: boolean;
}

// Query parameters for listing
export interface QueryUserDto {
  search?: string;
  role?: UserRole;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

// API response wrapper (reuse from bewerber if needed, or define here)
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  meta?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Role display configuration
export const UserRoleConfig: Record<UserRole, { label: string; color: string; bgColor: string }> = {
  ADMIN: { label: 'Administrator', color: 'text-red-700', bgColor: 'bg-red-100' },
  MANAGER: { label: 'Manager', color: 'text-purple-700', bgColor: 'bg-purple-100' },
  USER: { label: 'Benutzer', color: 'text-blue-700', bgColor: 'bg-blue-100' },
};

// Status display configuration
export const UserStatusConfig: Record<string, { label: string; color: string; bgColor: string }> = {
  active: { label: 'Aktiv', color: 'text-green-700', bgColor: 'bg-green-100' },
  inactive: { label: 'Inaktiv', color: 'text-gray-700', bgColor: 'bg-gray-100' },
};
